<template>
  <div class="read-edition">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12 title-col">
                  <h3>{{ magazine_edition.magazine.name }}</h3>
                  <span>{{
                    `${getMonthLabel(magazine_edition.month)} ${
                      magazine_edition.year
                    } nº ${magazine_edition.edition_number}`
                  }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 button-col" v-if="url_edition != ''">
                  <a :href="url_edition" target="_blank">
                    <button class="btn btn-primary float-right">
                      Visualizar versão digital
                    </button>
                  </a>
                </div>
                <div class="col-12 col-content">
                  <div
                    class="alert-empty"
                    v-if="magazine_content && magazine_content.length == 0"
                  >
                    Ainda não há conteúdo cadastrado
                  </div>
                  <div
                    class="magazine-content-item"
                    v-for="item in magazine_content"
                    v-bind:key="item.name"
                  >
                    <div class="title-magazine-content">
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="texts-content-magazine">
                      <div
                        class="text-content-magazine"
                        v-for="sub_item in item.sub_group_contents"
                        v-bind:key="sub_item.name"
                      >
                        <div
                          class="subitem-title"
                          v-if="item.sub_group_contents.length > 1"
                        >
                          <span>{{ sub_item.name }}:</span>
                        </div>
                        <div
                          class="text-item"
                          v-for="text in sub_item.items"
                          v-bind:key="text.id"
                        >
                          <div class="link">
                            <router-link
                              class="primary-a"
                              :to="{
                                name: redirect_text,
                                params: { text_id: text.id },
                              }"
                              >{{ text.title }}</router-link
                            >
                          </div>
                          <div class="page">{{ text.pivot.page_number }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";

export default {
  name: "read-edition",
  props: {
    id: Number,
  },
  data() {
    return {
      magazine_edition: {
        magazine: {},
      },
      magazine_content: [],
      logged: false,
      url_edition: "",
      redirect_text: "",
      items: [
        {
          text: "",
          route: "public.magazine-editions",
        },
        {
          text: "",
          active: true,
        },
      ],
    };
  },
  mounted() {
    if (!this.id) {
      let getItemParam = localStorage.getItem("params.read_edition_id");
      if (getItemParam) {
        this.id = getItemParam;
        localStorage.setItem("params.read_edition_id", null);
      } else {
        this.$router.push({ name: "Home" });
      }
    }
    bus.$emit("changeLoading", true);
    this.logged =
      localStorage.getItem("auth.user_id") != null &&
      localStorage.getItem("auth.user_id") != "";
    this.redirect_text = this.logged ? "client.read-text" : "";
    this.getDataObject(this.id);
    localStorage.setItem("params.read_edition_id", this.id);
  },
  methods: {
    getDataObject: function (id) {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/magazine_editions_public/${id}`
        )
        .then((response) => {
          this.magazine_edition = response.data;
          this.magazine_content = this.getMagazineContent(
            this.magazine_edition.texts
          );
          this.items[0].text = `Edições - ${this.magazine_edition.magazine.name}`;
          this.items[1].text = `${this.getMonthLabel(
            this.magazine_edition.month
          )} ${this.magazine_edition.year} nº ${
            this.magazine_edition.edition_number
          }`;

          if (this.logged) {
            this.getMagazineEditionPath(this.magazine_edition.id);
          }
          bus.$emit("changeLoading", false);
        });
    },
    getMagazineEditionPath: function (id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/get_edition_url/${id}`)
        .then((response) => {
          this.url_edition = response.data;
        });
    },
    getMagazineContent: function (arr) {
      if (arr.length == 0) {
        return [];
      }
      arr = arr.sort((a, b) => {
        return a.indice_id < b.indice_id ? -1 : 1;
      });

      let content_groups = [];

      let content_group = {
        name: arr[0].index.name,
        items: [],
        sub_group_contents: [],
      };

      arr.forEach((element) => {
        if (element.index.name != content_group.name) {
          content_groups.push(content_group);
          content_group = {
            name: element.index.name,
            items: [],
            sub_group_contents: [],
          };
        }
        content_group.items.push(element);
      });

      if (content_group.items.length > 0) {
        content_group.items = content_group.items.sort((a, b) => {
          return a.pivot.page_number < b.pivot.page_number ? -1 : 1;
        });
        content_groups.push(content_group);
      }

      content_groups.forEach((element) => {
        element.items = element.items.sort((a, b) => {
          return a.sub_indice_id < b.sub_indice_id ? -1 : 1;
        });
        element.items = element.items.sort((a, b) => {
          return a.pivot.page_number < b.pivot.page_number ? -1 : 1;
        });
        if (element.items.length > 0) {
          let obsIndex = 0;
          let find = false;
          do {
            if (!element.items[obsIndex].sub_index) {
              obsIndex++;
            } else {
              find = true;
            }
          } while (obsIndex < element.items && !find);

          let sub_content_group = {
            name: find ? element.items[obsIndex].sub_index.name : "",
            items: [],
          };

          element.items.forEach((subElement) => {
            if (
              subElement.sub_index &&
              subElement.sub_index.name != sub_content_group.name
            ) {
              sub_content_group.items = sub_content_group.items.sort((a, b) => {
                return a.pivot.page_number - b.pivot.page_number;
              });
              element.sub_group_contents.push(sub_content_group);
              sub_content_group = {
                name: subElement.sub_index.name ?? "",
                items: [],
              };
            }
            sub_content_group.items.push(subElement);
          });

          if (sub_content_group.items.length > 0) {
            sub_content_group.items = sub_content_group.items.sort((a, b) => {
              return a.pivot.page_number - b.pivot.page_number;
            });
            element.sub_group_contents.push(sub_content_group);
          }
        }
      });
      content_groups = content_groups.sort((a, b) => {
        return a.items[0].pivot.page_number - b.items[0].pivot.page_number;
      });
      
      return content_groups;
    },
    getMonthLabel: function (value) {
      if (value == "1") return "Janeiro";
      if (value == "2") return "Fevereiro";
      if (value == "3") return "Março";
      if (value == "4") return "Abril";
      if (value == "5") return "Maio";
      if (value == "6") return "Junho";
      if (value == "7") return "Julho";
      if (value == "8") return "Agosto";
      if (value == "9") return "Setembro";
      if (value == "10") return "Outubro";
      if (value == "11") return "Novembro";
      if (value == "12") return "Dezembro";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.read-edition {
  .alert-empty {
    color: #5f6064;
    text-align: center;
  }
  .title-col {
    text-align: center;
  }
  .col-content {
    margin-top: 12px;
  }
  .button-col {
    margin-bottom: 8px;
    margin-top: 8px;
  }
  .magazine-content-item {
    margin-bottom: 3vh;
    .title-magazine-content {
      color: $red_primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .texts-content-magazine {
      .text-content-magazine {
        margin-bottom: 2vh;
        .subitem-title {
          font-style: italic;
        }
        .text-item {
          position: relative;
          padding: 4px 35px 4px 8px;
          border-bottom: 1px solid rgb(224, 221, 221);
          margin-bottom: 10px;
          .primary-a {
            text-decoration: none;
            color: #5f6064;
          }
          .primary-a:hover {
            color: #212529;
          }
          .page {
            color: $red_primary;
            position: absolute;
            right: 0;
            top: 4px;
          }
        }
      }
    }
  }
}
</style>